module.exports = __webpack_public_path__ + "img/empty.2fda80d3.png";